import {connect} from 'react-redux';
import {AnyAction} from 'redux';
import {ThunkDispatch} from 'redux-thunk';

import NavigationProp from '../../../../../navigators/NavigationProp';

import Index, {
  DispatchProps,
  StateProps,
} from '../../../../../components/scene_form/effect_show_scene_command/edit/effects/Index';

import AppState from '../../../../../reducers/AppState';

import getSceneCommandForm from '../../../../../helpers/getSceneCommandForm';

import indexEffects, {
  Params as EffectIndexParams,
} from '../../../../../actions/effects/index';
import showBaseEffect from '../../../../../actions/base_effects/show';
import indexPositionedEffects, {
  Params as PositionedEffectIndexParams,
} from '../../../../../actions/positioned_effects/index';
import updateEffectUsageHistory, {
  Params as EffectUsageHistoryUpdateParams,
} from '../../../../../actions/effect_usage_histories/update';
import updateSceneCommandForm, {
  Params as SceneCommandFormUpdateParams,
} from '../../../../../actions/scene_command_forms/update';

import selectEntities from '../../../../../helpers/selectEntities';
import selectEntity from '../../../../../helpers/selectEntity';
import {enabledResourceFavorite} from '../../../../../helpers/ResourceAuthorizattion';

import {SceneFormEffectShowSceneCommandEditEffectsRouteProp} from '../../../../../navigators/RouteProps';

interface Props {
  navigation: NavigationProp;
  route: SceneFormEffectShowSceneCommandEditEffectsRouteProp;
}

const mapStateToProps = (state: AppState, props: Props): any => {
  const {navigation, route} = props;
  const {entities, queries, forms} = state;
  const {baseEffectId, parentSceneCommandId} = route.params;
  const sceneForm = forms.sceneForm;
  const effectsParams: EffectIndexParams = {
    baseEffectId,
  };
  const baseEffect = selectEntity(entities.baseEffects, baseEffectId);
  const effects = selectEntities(
    entities.effects,
    queries.effects,
    effectsParams,
  );
  const parentSceneCommandForm = getSceneCommandForm(
    state.forms.sceneCommandForms,
    parentSceneCommandId,
  );
  return {
    navigation,
    sceneForm,
    baseEffect,
    effectsParams,
    effects,
    parentSceneCommandForm,
    enabledFavorite: enabledResourceFavorite(state),
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<AppState, void, AnyAction>,
) => {
  return {
    indexEffects: (params: EffectIndexParams) => dispatch(indexEffects(params)),
    showBaseEffect: (id: number) => dispatch(showBaseEffect(id)),
    indexPositionedEffects: (params: PositionedEffectIndexParams) =>
      dispatch(indexPositionedEffects(params)),
    updateSceneCommandForm: (params: SceneCommandFormUpdateParams) =>
      dispatch(updateSceneCommandForm(params)),
    updateEffectUsageHistory: (
      id: number,
      params: EffectUsageHistoryUpdateParams,
    ) => dispatch(updateEffectUsageHistory(id, params)),
  };
};

export default connect<StateProps, DispatchProps, Props, AppState>(
  mapStateToProps,
  mapDispatchToProps,
)(Index);
